(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["av-bak-product-card-20261102"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__pcGalleryInit) return;
  window.__pcGalleryInit = true;

  function scroller(g) { return g.querySelector('.product-card__media'); }
  function slides(g) { return g.querySelectorAll('[data-pc-slide]'); }
  function dots(g) { return g.querySelectorAll('[data-pc-dot]'); }
  function stepW(g) { var s = scroller(g); return s ? s.clientWidth : 0; }
  function curIndex(g) { var s = scroller(g); var w = stepW(g); return (s && w) ? Math.round(s.scrollLeft / w) : 0; }

  function sync(g) {
    var idx = curIndex(g); var n = slides(g).length;
    var d = dots(g);
    for (var j = 0; j < d.length; j++) { d[j].classList.toggle('is-active', j === idx); }
    g.dataset.pcIndex = idx;
    g.classList.toggle('is-first', idx <= 0);
    g.classList.toggle('is-last', idx >= n - 1);
  }

  function goTo(g, idx) {
    var s = scroller(g); if (!s) return; var n = slides(g).length;
    if (idx < 0) idx = 0; if (idx > n - 1) idx = n - 1;
    s.scrollTo({ left: idx * stepW(g), behavior: 'smooth' });
  }

  // Arrows (desktop) scroll the native carousel
  document.addEventListener('click', function (e) {
    var next = e.target.closest('[data-pc-next]');
    if (next) { e.preventDefault(); e.stopPropagation(); var gn = next.closest('[data-pc-gallery]'); if (gn) goTo(gn, curIndex(gn) + 1); return; }
    var prev = e.target.closest('[data-pc-prev]');
    if (prev) { e.preventDefault(); e.stopPropagation(); var gp = prev.closest('[data-pc-gallery]'); if (gp) goTo(gp, curIndex(gp) - 1); return; }
  }, true);

  // Suppress the navigation click if the user actually swiped the carousel (moved > 8px)
  var downX = 0, downY = 0, moved = false;
  document.addEventListener('touchstart', function (e) {
    var g = e.target.closest && e.target.closest('[data-pc-gallery]'); if (!g) return;
    var t = e.touches[0]; downX = t.clientX; downY = t.clientY; moved = false;
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!e.touches || !e.touches[0]) return;
    var t = e.touches[0];
    if (Math.abs(t.clientX - downX) > 8 || Math.abs(t.clientY - downY) > 8) moved = true;
  }, { passive: true });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-pc-gallery] .product-card__media');
    if (a && moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
  }, true);

  // Keep dots + arrow visibility in sync with the native swipe
  var raf = 0;
  document.addEventListener('scroll', function (e) {
    var s = e.target;
    if (!s || !s.classList || !s.classList.contains('product-card__media')) return;
    var g = s.closest('[data-pc-gallery]'); if (!g) return;
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; sync(g); });
  }, true);

  function initAll() {
    var gs = document.querySelectorAll('[data-pc-gallery]');
    for (var i = 0; i < gs.length; i++) sync(gs[i]);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__pcGalleryInit) return;
  window.__pcGalleryInit = true;

  function scroller(g) { return g.querySelector('.product-card__media'); }
  function slides(g) { return g.querySelectorAll('[data-pc-slide]'); }
  function dots(g) { return g.querySelectorAll('[data-pc-dot]'); }
  function stepW(g) { var s = scroller(g); return s ? s.clientWidth : 0; }
  function curIndex(g) { var s = scroller(g); var w = stepW(g); return (s && w) ? Math.round(s.scrollLeft / w) : 0; }

  function sync(g) {
    var idx = curIndex(g); var n = slides(g).length;
    var d = dots(g);
    for (var j = 0; j < d.length; j++) { d[j].classList.toggle('is-active', j === idx); }
    g.dataset.pcIndex = idx;
    g.classList.toggle('is-first', idx <= 0);
    g.classList.toggle('is-last', idx >= n - 1);
  }

  function goTo(g, idx) {
    var s = scroller(g); if (!s) return; var n = slides(g).length;
    if (idx < 0) idx = 0; if (idx > n - 1) idx = n - 1;
    s.scrollTo({ left: idx * stepW(g), behavior: 'smooth' });
  }

  // Arrows (desktop) scroll the native carousel
  document.addEventListener('click', function (e) {
    var next = e.target.closest('[data-pc-next]');
    if (next) { e.preventDefault(); e.stopPropagation(); var gn = next.closest('[data-pc-gallery]'); if (gn) goTo(gn, curIndex(gn) + 1); return; }
    var prev = e.target.closest('[data-pc-prev]');
    if (prev) { e.preventDefault(); e.stopPropagation(); var gp = prev.closest('[data-pc-gallery]'); if (gp) goTo(gp, curIndex(gp) - 1); return; }
  }, true);

  // Suppress the navigation click if the user actually swiped the carousel (moved > 8px)
  var downX = 0, downY = 0, moved = false;
  document.addEventListener('touchstart', function (e) {
    var g = e.target.closest && e.target.closest('[data-pc-gallery]'); if (!g) return;
    var t = e.touches[0]; downX = t.clientX; downY = t.clientY; moved = false;
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!e.touches || !e.touches[0]) return;
    var t = e.touches[0];
    if (Math.abs(t.clientX - downX) > 8 || Math.abs(t.clientY - downY) > 8) moved = true;
  }, { passive: true });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-pc-gallery] .product-card__media');
    if (a && moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
  }, true);

  // Keep dots + arrow visibility in sync with the native swipe
  var raf = 0;
  document.addEventListener('scroll', function (e) {
    var s = e.target;
    if (!s || !s.classList || !s.classList.contains('product-card__media')) return;
    var g = s.closest('[data-pc-gallery]'); if (!g) return;
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; sync(g); });
  }, true);

  function initAll() {
    var gs = document.querySelectorAll('[data-pc-gallery]');
    for (var i = 0; i < gs.length; i++) sync(gs[i]);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
})();
  } catch(e) { console.error(e); }
})();

})();
